import React, { useEffect, useState } from 'react';
import { pagamentosApi } from '../api/api';

export default function TesteAdminPage() {
  const [periodo, setPeriodo] = useState<number>(7);
  const [tipo, setTipo] = useState<'dias' | 'horas'>('dias');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    pagamentosApi.getConfigTeste()
      .then(r => {
        setPeriodo(r.data.periodoTeste);
        setTipo(r.data.tipoTeste);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  async function salvar() {
    if (periodo < 0) { setErro('O período deve ser 0 ou maior'); return; }
    setSaving(true);
    setErro('');
    setSucesso(false);
    try {
      await pagamentosApi.atualizarConfigTeste(periodo, tipo);
      setSucesso(true);
      setTimeout(() => setSucesso(false), 3000);
    } catch {
      setErro('Erro ao salvar configuração');
    } finally {
      setSaving(false);
    }
  }

  const descricao = periodo === 0
    ? 'Sem período de teste. Usuários precisarão assinar imediatamente após o cadastro.'
    : `Novos usuários terão ${periodo} ${tipo} de acesso gratuito após o cadastro.`;

  return (
    <div className="space-y-6 max-w-xl">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Período de Teste Gratuito</h1>
        <p className="text-sm text-gray-500 mt-1">Configure o tempo de acesso gratuito para novos usuários após o cadastro</p>
      </div>

      <div className="rounded-xl border p-6 space-y-5 bg-white border border-gray-200">
        {loading ? (
          <div className="text-sm text-gray-400">Carregando...</div>
        ) : (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Duração do período de teste</label>
              <div className="flex gap-3">
                <input
                  type="number"
                  min={0}
                  value={periodo}
                  onChange={e => setPeriodo(Number(e.target.value))}
                  className="w-28 px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <select
                  value={tipo}
                  onChange={e => setTipo(e.target.value as 'dias' | 'horas')}
                  className="px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white border border-gray-200"
                >
                  <option value="dias">Dias</option>
                  <option value="horas">Horas</option>
                </select>
              </div>
              <p className="text-xs text-gray-400 mt-1">Use 0 para desativar o período de teste gratuito</p>
            </div>

            <div className={`rounded-lg px-4 py-3 text-sm ${periodo === 0 ? ' ' : ' '} bg-red-50 text-red-600`}>
              {descricao}
            </div>

            {erro && (
              <div className="rounded-lg px-4 py-3 text-sm bg-red-50 text-red-600">{erro}</div>
            )}
            {sucesso && (
              <div className="rounded-lg px-4 py-3 text-sm bg-emerald-50 text-emerald-700">Configuração salva com sucesso!</div>
            )}

            <button
              onClick={salvar}
              disabled={saving}
              className="w-full sm:w-auto px-6 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
            >
              {saving ? 'Salvando...' : 'Salvar configuração'}
            </button>
          </>
        )}
      </div>

      <div className="bg-yellow-50 border border-[rgba(245,158,11,0.3)] rounded-xl p-4 text-sm text-yellow-700 space-y-1">
        <p className="font-semibold">Importante</p>
        <p>Esta configuração só afeta novos cadastros. Usuários já registrados não terão sua assinatura alterada.</p>
      </div>
    </div>
  );
}
